import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MetadataDataType } from '../../../../../../../../models/metadata';
import { DateFilterComponent } from '../date-filter/date-filter.component';
import { NumberFilterComponent } from '../number-filter/number-filter.component';
import { TextArrayFilterComponent } from '../text-array-filter/text-array-filter.component';
import { TextFilterComponent } from '../text-filter/text-filter.component';

@Component({
  selector: 'app-any-filter',
  standalone: true,
  templateUrl: './any-filter.component.html',
  imports: [DateFilterComponent, NumberFilterComponent, TextArrayFilterComponent, TextFilterComponent],
  styleUrl: './any-filter.component.scss'
})
export class AnyFilterComponent {
  @Input() paramsGroup!: FormGroup;
  @Input() columnDataType?: MetadataDataType;
}
